import React, { memo, useState } from 'react';
import classNames from 'classnames';

import { ButtonIcon } from '../../../design-system';
import { ArrowDownSLineIcon, ArrowUpSLineIcon } from '../../../design-system/Icons';
import RichTextArea from '../../../design-system/RichTextArea/RichTextArea';

const OverviewTabSection = ({ tab }) => {
    const text = tab.detail?.text;

    const [isExpanded, setIsExpanded] = useState(true);
    const expandButtonIcon = isExpanded ? ArrowUpSLineIcon : ArrowDownSLineIcon;

    const toggleExpand = (e) => {
        e.stopPropagation();
        setIsExpanded((isExpanded) => !isExpanded);
    };

    const className = classNames(
        'rounded-2.5 border-1 border-neutral-200 p-4 bg-white flex flex-col gap-5 lg:gap-6'
    );

    return (
        <div className={className}>
            <div
                className="flex items-center justify-between gap-4 cursor-pointer"
                onClick={toggleExpand}
            >
                <p className="font-heading-bold text-heading-bold-m text-black select-none">
                    Overview
                </p>

                <ButtonIcon type="link" size="xs" icon={expandButtonIcon} onClick={toggleExpand} />
            </div>

            <div className={isExpanded ? 'block' : 'hidden'}>
                <RichTextArea
                    value={text}
                    previewOnly
                    isBorderHidden
                    autoExpand
                    minHeight={38}
                    previewCustomClassName="!p-2.5"
                />
            </div>
        </div>
    );
};

export default memo(OverviewTabSection);
